import type { ReactNode } from 'react';

/**
 * سطر شرح تحت حقل أو زر، بلغة صاحب الشركة لا لغة المحاسب — مكوّن واحد بدل نصوص
 * رمادية متفرقة، حتى يجد العميل الإجابة تحت السؤال ولا يرجع للبائع ليشرح.
 * `block` لسطر مستقل تحت زر أو صف أزرار؛ بدونه يُوضع داخل `<label>` تحت الحقل.
 */
export default function Hint({
  children,
  block = false,
}: {
  children: ReactNode;
  block?: boolean;
}) {
  return block ? (
    <p className="hint hint-block">{children}</p>
  ) : (
    <span className="hint">{children}</span>
  );
}
